import { useCubeContext } from 'modules/Cube/communication/internal/cube.domain.context'

interface UsePopoverCounterSignersResult {
  isVisible: boolean
  contacts: Array<{
    id: string
    name: string
    email: string
  }>
}

export function usePopoverCounterSigners(): UsePopoverCounterSignersResult {
  const cubeContext = useCubeContext()
  const selectedCounterSigners =
    cubeContext.queries.rawData.data.quote.counterSigners || []
  const isSignaturesEnabled =
    cubeContext.queries.rawData.data.quote.isSignaturesEnabled

  if (!selectedCounterSigners?.length || !isSignaturesEnabled) {
    return {
      isVisible: false,
      contacts: []
    }
  }

  return {
    isVisible: true,
    contacts: selectedCounterSigners.map((signer, index) => ({
      id: `counter-signer-${index}`,
      name: signer.name || signer.email,
      email: signer.email
    }))
  }
}
